import React from "react"
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, Link, Grid} from "@material-ui/core";
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import Copyright from "./Copyright";

const useStyles = makeStyles((theme) => ({
    footer: {
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
    backgroundColor: "#000",
    color: theme.palette.grey[300],
    },
}));
const Footer = () => {
    const classes = useStyles();
    return(
    <footer className={classes.footer}>
        <Container maxWidth="lg">
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <Typography variant="h6" align="center">Let Us Help You </Typography>
                    <Typography variant="subtitle1" align="center">
                        We're here for you everytime, if you have issues with delivery or just a general help on how we work,
                        you can send a mail to contact@betastore.com or call us at +234 807 BETASTORE
                    </Typography>
                </Grid>
                <Grid item  xs={12} sm={4}>
                    <Typography variant="h6" align="center">How to Order </Typography>
                    <Typography variant="subtitle1" align="center">
                        To place an order please note that your store needs to be registered with us, you can call us at +234 807 BETASTORE
                        to place an order
                    </Typography>
                </Grid>
                <Grid item  xs={12} sm={4}>
                    <Typography variant="h6" align="center">Connect With Us </Typography>
                    <Grid container direction="row" justify="center" alignItems="center">
                        <Grid item xs={3}>
                        <Typography variant="h5" align="center">
                            <Link href="https://www.facebook.com" variant="h6" color="inherit"><FacebookIcon /></Link>
                        </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5" align="center">
                            <Link href="https://www.twitter.com" variant="h6" color="inherit"><TwitterIcon /></Link>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5" align="center">
                            <Link href="https://www.youtube.com" variant="h6" color="inherit"><YouTubeIcon /></Link>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5" align="center">
                            <Link href="https://www.instagram.com" variant="h6" color="inherit"><InstagramIcon /></Link>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
           <Copyright />
        </Container>
    </footer>
    )
}
export default Footer